import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { CONFIG_FEATURE_KEY } from './config.state';
import { ConfigEffects } from './effects/config.effects';
import { configReducer } from './reducers/config.reducer';
import { selectConfigEntries } from './selectors/config.selector';

/**
 * Registers the config feature slice. `ConfigService.init()` loads the data from the backend
 * and dispatches `configLoaded`; `ConfigEffects` then mirrors the slice to the generic
 * persistence layer, which caches it in the concurrency store under the default `configSlice`
 * key so config is available offline. The backend stays the source of truth (see the effect).
 */
@NgModule({
    imports: [StoreModule.forFeature(CONFIG_FEATURE_KEY, configReducer), EffectsModule.forFeature([ConfigEffects])],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: CONFIG_FEATURE_KEY,
                persistSelector: selectConfigEntries,
                localOnly: true,
            },
        },
    ],
})
export class ConfigStoreModule {}
